/**
 * Session Expired Dialog
 * Modal shown when the user's session has expired and cannot be refreshed
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@mono/ui-components';
export function SessionExpiredDialog({ open, onLogin }) {
    return /*#__PURE__*/ _jsx(AlertDialog, {
        open: open,
        children: /*#__PURE__*/ _jsxs(AlertDialogContent, {
            children: [
                /*#__PURE__*/ _jsxs(AlertDialogHeader, {
                    children: [
                        /*#__PURE__*/ _jsx(AlertDialogTitle, {
                            children: "Session Expired"
                        }),
                        /*#__PURE__*/ _jsx(AlertDialogDescription, {
                            children: "Your session has expired. Please log in again to continue."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(AlertDialogFooter, {
                    children: /*#__PURE__*/ _jsx(AlertDialogAction, {
                        onClick: onLogin,
                        children: "Log In Again"
                    })
                })
            ]
        })
    });
}
